var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('button',{staticClass:"button",attrs:{"id":_vm.name}},[_c('a',{key:_vm.id,attrs:{"target":_vm.newTab ? '_blank' : '',"href":_vm.link}},[_vm._v(_vm._s(_vm.name))])]),_c('p',[_vm._v(" | ")])])}
var staticRenderFns = []

export { render, staticRenderFns }